export default __webpack_public_path__ + "static/1930-adf251863eb3b1edc55af361234bfd26.gif";